import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import ElSelectV2 from 'el-select-v2'
import PublicComponents from '@/components/index'
// import './styles/common.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import '@/styles/index.scss' // global css
import * as filters from './filters' // global filters
import App from './App'
import store from './store'
import router from './router'
import axios from 'axios';
import baseMixin from '@/components/Mixin/base';
import '@/icons' // icon
import '@/permission'
import {getLoginData, getToken} from '@/utils/auth' // permission control

import VueTouch from 'vue-touch'
import vueSwiper from 'vue-awesome-swiper'  //引入vue-awesome-swiper
import 'swiper/dist/css/swiper.css'  //引入样式
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(vueSwiper)  //使用插件
Vue.use(ElementUI, { locale })
Vue.use(ElSelectV2)
Vue.prototype.$EventBus = new Vue();
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock'
// if (process.env.NODE_ENV === 'production') {
//   mockXHR()
// }
// axios.defaults.baseURL = 'http://26y016i298.zicp.vip/manager'

// axios.defaults.baseURL = 'http://192.168.31.179:18080/manager' //李威龙
//axios.defaults.baseURL = 'http://192.168.31.68:19010/api'  //李振湘
// axios.defaults.baseURL = 'http://192.168.31.68:19010/api'  //李振湘
 // axios.defaults.baseURL = 'http://z118.nat300.top/manager'

//axios.defaults.baseURL = 'http://192.168.31.244:19010/api'  //测试接口s
//axios.defaults.baseURL = 'http://service.iedai.cn:19010/api'  //测试接口
//axios.defaults.baseURL = 'http://192.168.0.244:19010/api'  //测试接口
//
//axios.defaults.baseURL = 'http://192.168.31.65:19010/api'  //测试接口
//axios.defaults.baseURL="http://139.9.185.118:19010/api/";//测试
//axios.defaults.baseURL="http://127.0.0.1:19010/api/";//测试
//axios.defaults.baseURL="http://47.99.192.182:19010/api/";//测试
// axios.defaults.baseURL="http://47.113.88.33:19010/api/";//测试
// axios.defaults.baseURL="http://120.76.130.250:19010/api/";//测试
// axios.defaults.baseURL="http://139.9.185.118:19010/api/";//菲尼基测试

//axios.defaults.baseURL="http://120.76.130.250:19020/api/";//绿沃生产

//axios.defaults.baseURL="http://139.9.185.118:19020/api/";//生产
// axios.defaults.baseURL="http://192.168.0.244:9528";//生产
// axios.defaults.baseURL="http://www.zlgcloud.com";//生产
const env = process.env.NODE_ENV;
console.log(env,'env');
if(env == 'development'){
  axios.defaults.baseURL= 'https://zws.zlgcloud.com/'//测试服
  // axios.defaults.baseURL= 'https://zws-staging.zlgcloud.com/'//测试服
} else if(env == 'test'){
  axios.defaults.baseURL= window.location.origin;//测试服
} else if(env == 'newmode' || env == 'production'){
  axios.defaults.baseURL= 'https://zws.zlgcloud.com/';//生产服
  // axios.defaults.baseURL= 'https://zws-staging.zlgcloud.com/';//生产服
}

axios.defaults.withCredentials = true;
Vue.prototype.$ident = 'Homegrid_';
// Vue.prototype.$ident = 'RENON_';
// axios.defaults.baseURL = 'http://192.168.31.244:19010/api'


axios.interceptors.request.use(function (config) {
//   let data = getLoginData();
//
//  // config.headers['Cookie'] = "11111111";
// config.headers['jwt'] = data.ujwt;
  // console.log(config)
  return config;
}, function (error) {
  return Promise.reject(error);
});

Vue.use(Viewer)
Vue.use(VueTouch, {name: 'v-touch'})
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.prototype.$axios = axios;
// set ElementUI lang to EN
Vue.use(ElementUI);
Vue.use(PublicComponents);
Vue.mixin(baseMixin);
Vue.config.productionTip = false
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
